import * as React from "react";
import { Link, Stack, Typography } from "@mui/material";
import { useParams, Link as RouterLink } from "react-router-dom";
import DetailPage from "../../../../components/common/detailPage/detailPage";
import { SimpleBreadcrumbs } from "../../../../components/navigation/simpleBreadcrumbs";

export type GroupReportDetailProps = {
    pKey: string;
    target: string;
};

const GroupReportDetail: React.FC = (props) => {
    const params = useParams<GroupReportDetailProps>();
    const detailEl = React.useRef<HTMLDivElement>(null);
    const target: string =
        params.target !== undefined && !isNaN(Number(params.target)) ? params.target : "0";

    const tablist: [string, number, React.ReactNode][] = [
        ["Details", 0, <></>],
    ];

    const breadcrumbs = (
        <Stack direction={"row"} spacing={3}>
            <SimpleBreadcrumbs>
                <Typography variant="h6" color="text.primary">
                    <Link key="findResourceLink" component={RouterLink} to="/assessments">
                        Group Report Details
                    </Link>
                </Typography>
            </SimpleBreadcrumbs>
        </Stack>
    );

    return (
        <div ref={detailEl}>
            <DetailPage
                breadcrumbs={breadcrumbs}
                descriptor={"group report"}
                tablist={tablist}
                activeTab={+target}
                identifier="group-report-details"
            ></DetailPage>
        </div>
    );
};

export default GroupReportDetail;
